import { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { settingsService, type PublicSettings } from '../services/settings.service';
import { Loader2, Info } from 'lucide-react';

export default function About() {
  const [settings, setSettings] = useState<PublicSettings>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await settingsService.getPublicSettings();
        setSettings(data || {});
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      {/* Hero */}
      <section className="bg-gradient-to-br from-brand-400 to-brand-700 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-white mb-3">Sobre</h1>
            <p className="text-brand-100">Conheça mais sobre o portal</p>
          </div>
        </div>
      </section>

      {/* Conteúdo dinâmico */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white border rounded-lg p-6 md:p-8">
            {loading ? (
              <div className="text-center py-12">
                <Loader2 className="size-8 animate-spin text-brand-600 mx-auto mb-3" />
                <p className="text-gray-600">Carregando conteúdo...</p>
              </div>
            ) : settings.about_page_content ? (
              <div className="prose max-w-none whitespace-pre-wrap leading-relaxed text-gray-800">
                {settings.about_page_content}
              </div>
            ) : (
              <div className="text-center py-12 text-gray-600">
                <Info className="size-6 mx-auto mb-2 text-gray-400" />
                <p>O conteúdo da página "Sobre" ainda não foi publicado.</p>
              </div>
            )}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

